import { publishOfferNative } from '../../../actions/webview';
import { TThunkAction } from '../../../../common/types/thunk';
import { mapPublishTerms } from './utils';
import { selectIsAutoProlongChecked } from '../../../selectors/checkoutInfo';
import { selectPublicationTokens, selectServiceUnavailableReason } from '../../../selectors/publishTerms';
import { PROMOTION_SECTION_ID } from '../../../constants/nodeIds';
import { selectIsPublishToHiddenBase } from '../../../selectors/publishAvailable';
import { scrollToElement } from '../../../utils/layout';
import { publishOfferStart } from '../../../actions/publishInfo';
import { logPublicationTokens } from '../../../utils/logPublicationTokens';
import { getPublishTerms } from '../../../utils/getPublishTerms';

export const publishOfferThunk =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { webview, logger }) => {
    const state = getState();

    const unavailableReason = selectServiceUnavailableReason(state);
    const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

    if (unavailableReason && !isPublishToHiddenBase) {
      scrollToElement(PROMOTION_SECTION_ID);

      return;
    }

    dispatch(publishOfferStart());

    const isAutoprolongChecked = selectIsAutoProlongChecked(state);
    const publicationTokens = selectPublicationTokens(state);

    logPublicationTokens(logger, state, publicationTokens, 'publishOffer');

    const terms = getPublishTerms(state);

    const publishTerms = mapPublishTerms({ isAutoprolongChecked, publicationTokens, terms });

    webview.sendAction(publishOfferNative({ publishTerms }));
  };
